import { RadioButtonNew, RadioGroupNew } from "@octopusdeploy/design-system-components";
import React from "react";
import { ExpandableFormSection, Summary } from "~/components/form";
type BulkDeploymentProps = {
    isEnabled: boolean;
    onChange: (isEnabled: boolean) => void;
};
export function BulkDeployment({ isEnabled, onChange }: BulkDeploymentProps) {
    const description = "Use a server task when creating two or more deployments";
    const label = "Bulk Deployment Creation";
    const name = "BulkDeploymentCreation";
    return (<ExpandableFormSection key="IsBulkDeploymentCreationEnabled" errorKey="IsBulkDeploymentCreationEnabled" title={label} summary={isEnabled ? Summary.default("Enabled") : Summary.summary("Disabled")} help={description}>
            <RadioGroupNew value={isEnabled} onChange={onChange} label={label} description={description} hideLabel={true} hideDescription={true}>
                <RadioButtonNew value={true} label="Enabled" name={name} hasDefaultMarker={true}/>
                <RadioButtonNew value={false} label="Disabled" name={name}/>
            </RadioGroupNew>
        </ExpandableFormSection>);
}
